/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import DoctorAppointmentHeader from "./Header/DoctorAppointmentHeader";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import AppointmentDetailsPopup from "./Popup/AppointmentDetailsPopup";
import AppointmentListFilterPopup from "./Popup/AppointmentListFilterPopup";
import SaveAppointmentPopup from "components/Common/Popup/SaveAppointmentPopup";

const DoctorAppointmentListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedAppointmentIds, setSelectedAppointmentIds] = useState([]);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all appointments
  const getAllAppointments = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_AGENDA +
        `?token=${token}&issent=true`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += "&filters=" + JSON.stringify(sanitizedQuery);
      }

      console.log("requestUrl in get all appointments", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      // console.log("response in get all appointments", response);

      if (response.status) {
        setAppointmentList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for reset filter
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  //function for remove tag from appointment
  const removeTagFromAppointment = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_AGENDA;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedAppointmentId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      // setAppointmentList((prev) => replaceListByIds(prev, data));
      setReloadData(true);
    }, 1000);
  };

  // useEffect(() => {
  //   getAllAppointments();
  // }, []);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllAppointments();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllAppointments();
      setReloadData(false);
    }
  }, [reloadData]);

  // Table columns
  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#appointmentDetailsPopup"
            aria-controls="appointmentDetailsPopup"
            onClick={() => {
              setSelectedAppointmentId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Appointment Date",
        accessorKey: "date",
        size: 150,
        Cell: ({ row }) => (
          <span>{getDateFormatInSpanish(row.original.date)}</span>
        ),
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedAppointmentId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromAppointment(
                              [tag._id],
                              row.original._id
                            );
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedAppointmentId &&
                          selectedAppointmentId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedAppointmentIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        header: "Start Time",
        accessorKey: "starttime",
      },
      {
        header: "End Time",
        accessorKey: "endtime",
      },
      //patient
      {
        header: "Patient",
        accessorKey: "sendername",
        size: 200,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex align-items-center gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.senderimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.senderimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.sendername}</span>
            </p>
          </div>
        ),
      },
      //doctor
      {
        header: "Doctor",
        accessorKey: "receivername",
        size: 200,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex align-items-center gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.receiverimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.receiverimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.receivername}</span>
            </p>
          </div>
        ),
      },

      //company
      {
        header: "Clinic",
        accessorKey: "companyname",
        size: 200,
        Cell: ({ row }) => (
          <div
            className={
              row.original.companyname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.companylogo == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.companylogo
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.companyname}</span>
            </p>
          </div>
        ),
      },
      //location
      {
        header: "Location",
        accessorKey: "location",
      },
      //duration
      {
        header: "Duration",
        accessorKey: "duration",
        Cell: ({ row }) => <span>{row.original.duration} hours</span>,
      },
    ],
    [selectedTagId, selectedAppointmentId]
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    setSelectedAppointmentIds(selectedIdsArray);
  }, [rowSelection]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CLINIC_MANAGEMENT") &&
      moduleAccess.includes("MOD_DOCTOR_APPOINTMENT_LIST"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Doctor Appointments")}
          />
          <div className="container-fluid px-lg-5">
            <DoctorAppointmentHeader
              reloadList={resetFilterData}
              selectedItemIds={selectedAppointmentIds}
            />

            {/* Material React Table or Placeholder */}
            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <MaterialReactTable
                columns={columns} // map columns to be displayed with api data,
                data={appointmentList} // data from api to be displayed
                enableGrouping // to enable grouping of column
                enableRowSelection // enable showing checkbox
                getRowId={(row) => row._id} // map which value to select with row checkbox
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ rowSelection, columnOrder }}
                initialState={{ rowSelection, columnOrder }} //pass our managed row selection state to the table to use
                defaultColumn={{
                  minSize: 20,
                  maxSize: 300,
                  size: 50,
                }}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: "60vh",
                  },
                }}
                enableStickyHeader
              />
            )}
          </div>

          <SaveAppointmentPopup afterPopupClose={getAllAppointments} />

          <AppointmentDetailsPopup
            selectedAppointmentId={selectedAppointmentId}
            setSelectedAppointmentId={setSelectedAppointmentId}
          />

          <AppointmentListFilterPopup
            columns={columns}
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilterData}
            moduleSlug="doctorappointmentlist"
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
          />

          <AddLabelModal
            selectedIds={selectedAppointmentIds}
            moduleName="eventagenda"
            afterTagModalClose={afterModalActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setSelectedAppointmentIds([]);
              setRowSelection({});
            }}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default DoctorAppointmentListBody;
